<template>
    <div>
        <div class="fillter--doc d-flex justify-content-center">
            <div class="col-6">
                <div class="form-group row flex-wrap">
                    <label class="col-sm-3" style="min-width: 132px">キャンペーン名</label>
                    <div class="col-sm-9">
                        <Multiselect
                            :id="`select-campaign`"
                            :value.sync="filterDoc.campaign"
                            :options="listDataMasterCampaign"
                            :config.sync="configSelectCampaign"
                        />
                    </div>
                </div>
                <!-- <div class="form-group row">
                    <label class="col-sm-3" style="min-width: 132px">{{ $t('document.formatFileEx') }}</label>
                    <div class="col-sm-9">
                        <Multiselect
                            :id="`select-format--file`"
                            :value.sync="filterDoc.format_file"
                            :options="listTypeFormat"
                            :config.sync="configSelectTypeFormat"
                        />
                    </div>
                </div> -->
                <div class="form-group row">
                    <label class="col-sm-3" style="min-width: 132px">{{ $t('document.dateTimeExport') }}</label>
                    <div class="col-sm-9">
                        <div class="d-flex align-items-center mb-2">
                            <DateNormal
                                :full_date.sync="filterDoc.start_date_export"
                                :config="{
                                    error: false
                                }"
                            >
                            </DateNormal>
                            から
                        </div>
                        <div class="d-flex align-items-center mb-2">
                            <DateNormal
                                :full_date.sync="filterDoc.end_date_export"
                                :config="{
                                    error: false
                                }"
                            >
                            </DateNormal>
                            まで
                        </div>
                        <small>※年、年月のみの入力でも検索可能です。</small>
                    </div>
                </div>

                <div class="text-center mt-4 position-relative">
                    <button type="button" @click="onHandleClear()" class="btn btn-common btn-outline-primary">
                        <i class="ri-restart-line"></i>{{ $t('btn.clear') }}
                    </button>
                    <button type="button" @click="onHandleSearch()" class="btn btn-common btn-primary ml-3">
                        <i class="ri-search-line"></i>{{ $t('btn.search') }}
                    </button>
                </div>
            </div>
        </div>

        <div class="text-left mb-3">
            <button class="btn btn-primary mr-3" @click="handleRefresh">
                <i class="ri-refresh-line"></i>
            </button>
            <button class="btn btn-common btn-common-delete btn-outline-danger" :disabled="listDocDel.length <= 0" @click="handleDeleteDocEx">
                <i class="ri-delete-bin-2-line"></i>{{ $t('btn.delete') }} {{ listDocDel.length > 0 ? `( ${listDocDel.length} )` : '' }}
            </button>
        </div>

        <TableListComponent
            :config="configTable"
            :dataList="historyListDocument"
            :isLoading="isLoadingTable"
            :configPage.sync="configPage"
            :visibleAction="false"
            :isCheckedAll="isCheckAllExcute"
            @onChangePage="getHistory()"
            @toggleCheckAll="onHandleCheckAll"
        >
            <template #row="{ row }">
                <tr>
                    <td class="text-left">
                        <div>
                            <InputCheckBox class="mx-2 mb-2" :model.sync="listDocDel" :id="`check-doc_delete${row.id}`" :value="row.id" :label="``" />
                        </div>
                    </td>
                    <td class="text-left">
                        <div class="el-table__cell">{{ row?.job?.campaign?.name }}</div>
                    </td>
                    <td class="text-left">
                        <div class="el-table__cell">
                            <a target="_blank" :href="row.url" v-b-tooltip.hover :title="row?.name ?? ''">{{ row.name }}</a>
                        </div>
                    </td>
                    <td>
                        <div class="text-center p-2 rounded" :style="`background-color: ${handleBgStatus(row.status)}; color:#ffff;`">
                            {{ $t(row.status) }}
                        </div>
                    </td>
                    <td>
                        <div class="el-table__cell">
                            {{ row.file_type }}
                        </div>
                    </td>
                    <td>
                        <div class="el-table__cell">
                            {{ formatDateCommon(row.created_at, 'dateTimeJP') }}
                        </div>
                    </td>
                    <td>
                        <div class="el-table__cell">{{ row.size }}mb</div>
                    </td>
                </tr>
            </template>
        </TableListComponent>
    </div>
</template>

<script>
import TableListComponent from '@/components/TableList/main.vue';

import { campaignMethods, masterMethods } from '@/state/helpers';
import { formatDateCommon } from '@/utils/format';
import { InputCheckBox } from '@/components/Input';
import { cloneDeep } from 'lodash';
import { showMessage } from '@/utils/messages';
import { onHandleShowConfirm } from '@/utils/handlers';

import Multiselect from '@/components/Multiselect/main.vue';
import DateNormal from '@/components/DateCustoms/DateNormal/main.vue';

export default {
    components: {
        TableListComponent,
        InputCheckBox,
        Multiselect,
        DateNormal
    },
    props: {
        activeTab: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            isLoadingTable: false,
            historyListDocument: [],
            configTable: {
                headers: [
                    {
                        checkAll: true,
                        width: 60
                    },
                    {
                        label: 'キャンペーン名',
                        width: 640
                    },
                    {
                        label: 'ファイル名',
                        width: 330
                    },
                    {
                        label: 'ステータス',
                        width: 105
                    },
                    {
                        label: '形式',
                        width: 80
                    },
                    {
                        label: '時間',
                        width: 220
                    },
                    {
                        label: 'サイズ',
                        width: 80
                    }
                ]
            },
            configPage: {
                total: 0,
                limit: 10,
                page: 1
            },
            listDocDel: [],
            listDataMasterCampaign: [],
            listTypeFormat: [
                {
                    id: 1,
                    name: 'xlsx'
                },
                {
                    id: 2,
                    name: 'pptx'
                },
                {
                    id: 3,
                    name: 'docx'
                },
                {
                    id: 4,
                    name: 'zip'
                }
            ],
            configSelectCampaign: {
                trackBy: 'id',
                label: 'name',
                error: false,
                errorField: '',
                isRemove: false,
                loading: false
            },
            configSelectTypeFormat: {
                trackBy: 'id',
                label: 'name',
                error: false,
                errorField: '',
                isRemove: false,
                loading: false
            },
            filterDoc: {
                campaign: null,
                format_file: null,
                start_date_export: '',
                end_date_export: ''
            }
        };
    },
    computed: {
        isCheckAllExcute() {
            if (this.listDocDel?.length <= 0 || this.historyListDocument?.length <= 0) return false;
            return this.listDocDel?.length === this.historyListDocument?.length;
        }
    },
    methods: {
        ...campaignMethods,
        ...masterMethods,

        getQueryString() {
            let query = [`page=${this.configPage.page}`, `limit=${this.configPage.limit}`, `sorts[id]=desc`];
            let copyFilterDoc = cloneDeep(this.filterDoc);
            copyFilterDoc.campaign = copyFilterDoc?.campaign?.id ?? null;
            copyFilterDoc.format_file = copyFilterDoc?.format_file?.name ?? null;
            if (copyFilterDoc) {
                for (const [key, value] of Object.entries(copyFilterDoc)) {
                    if (key && value) {
                        if (!['start_date_export', 'end_date_export', 'format_file'].includes(key)) query.push(`has[${key}]=${value}`);
                        switch (key) {
                            case 'format_file':
                                query.push(`filters[${key}]=${value}`);
                                break;
                            case 'start_date_export':
                                query.push(`from[${key}]=${value}`);
                                break;
                            case 'end_date_export':
                                query.push(`to[${key}]=${value}`);
                                break;
                        }
                    }
                }
            }
            return query.join('&');
        },

        handleRefresh() {
            this.configPage.page = 1;
            this.getHistory();
        },

        getHistory() {
            this.historyListDocument = [];
            this.listDocDel = [];
            this.isLoadingTable = true;
            let query = this.getQueryString();
            this.historyDocuments(query).then((data) => {
                this.historyListDocument = data.data;
                this.configPage.total = data._metadata.total;
                this.configPage.limit = data._metadata.limit * 1;
                if (!this.historyListDocument.length && this.configPage.page !== 1) {
                    this.configPage.page = 1;
                    this.getHistory();
                } else {
                    this.isLoadingTable = false;
                }
            });
        },

        formatDateCommon(date, type) {
            return formatDateCommon(date, type);
        },

        handleBgStatus(status) {
            switch (status) {
                case 'success':
                    return '#1cbb8c';
                case 'processing':
                    return '#fea217';
                case 'failed':
                    return '#ea4335';
            }
        },

        async handleDeleteDocEx() {
            const confirm = await onHandleShowConfirm({ text: `削除してもよろしいですか。` });
            if (confirm) {
                try {
                    const dataRes = await this.deleteHistoryDocuments({ id: this.listDocDel });
                    if (dataRes?.code === 200) {
                        showMessage(dataRes.code, this.$bvToast, '削除に成功しました。');
                        this.getHistory();
                    }
                } catch (error) {
                    console.log('error', error);
                    showMessage(error?.code, this.$bvToast, error?.message);
                }
            }
        },

        onHandleCheckAll(pCheck) {
            this.listDocDel = pCheck ? this.historyListDocument.map((ohist) => ohist.id) : [];
        },

        onHandleClear() {
            this.filterDoc = {
                campaign: null,
                format_file: null,
                start_date_export: '',
                end_date_export: ''
            };
            this.getHistory();
        },

        onHandleSearch() {
            this.getHistory();
        },

        async getMasterCampaign() {
            try {
                const dataRes = await this.listMaster('all/campaigns');
                this.listDataMasterCampaign = dataRes;
            } catch (error) {
                console.log('error', error);
            }
        }
    },
    watch: {
        activeTab: {
            handler: function (tab) {
                if (tab == 1) this.getHistory();
            },
            deep: true
        }
    },
    mounted() {
        this.getMasterCampaign();
    }
};
</script>

<style lang="scss" scoped></style>
